var _path, _path2, _circle;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconProducts(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.3 21.6h0z",
    fill: "none",
    stroke: "#050505",
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4 23c-.6 0-1.3-.3-1.7-.7l-10-10c-.4-.5-.7-1.1-.7-1.7s.3-1.3.7-1.7l7.1-7.1c.9-.9 2.5-.9 3.4 0l10 10c.6.6.8 1.4.7 2.2l-1.1 6c-.2 1-1 1.8-2 2l-6 1.1c-.1-.1-.2-.1-.4-.1zm-.3-2.1c.1.1.2.1.4.1l6-1.1c.2 0 .3-.2.3-.3l1.1-6c0-.1 0-.3-.1-.4l-10-10c-.2-.2-.4-.2-.6 0l-7.1 7.1c-.2.2-.2.4 0 .6l10 10z",
    fill: "#050505"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16.4,
    cy: 16,
    r: 1.5,
    opacity: 0.5,
    fill: "#050505"
  })));
}

export default SvgIconProducts;